// ---------------------------------------------------------------------------
// LANDING_GRAPH — the demo graph that assembles itself in the "It draws the map"
// step. This is a REAL Naumu space-export (the "Anchorpoint Labs" research
// space), projected down to only what the reveal needs — `{id, label, type,
// content}` per node, `{source, target, isParent, label}` per edge, and schema
// type colors — with UUIDs remapped to short ids and minified (~110KB, from a
// 347KB full export). `parseGraphExport(LANDING_GRAPH)` is the only contract,
// so a different export can be dropped in by regenerating landing-graph.json.
//
// The blob lives in landing-graph.json (kept out of the initial bundle — its
// only importer, ConnectedGraphScrollytell, is loaded via next/dynamic).
// ---------------------------------------------------------------------------

import landingGraph from './landing-graph.json';

export const LANDING_GRAPH: unknown = landingGraph;
